import { createAction } from "@reduxjs/toolkit";

export interface AuthError {
  name: string;
  message: string;
}

export const handleAuthError = createAction<AuthError>("auth/handleAuthError");

// Clears the reported error once it has been surfaced. Needed for errors that do
// not end the session (403): without it the slice keeps the same value and an
// identical second refusal would go unnoticed.
export const resetAuthError = createAction("auth/resetAuthError");
